<template>
  <div>
    <Filtro @projetoAstecFiltrados="atualizarFiltro" />

    <Relatorios />

    <div>
      <div class="text-center" v-if="loadingGridProjetos">
        <b-spinner class="ms-2" variant="primary"></b-spinner>
      </div>

      <Grid
        v-else
        :items="projetosListados"
        :filtro="filtroProjetoAstec"
        :default-mensagem="mensagemGrid"
        :is-loading="loadingGridProjetos"
        @projetoAstecFiltrados="atualizarFiltro"
      />
    </div>
  </div>
</template>

<script lang="js">
import Filtro from "@/components/astec/projetos/filtro";
import Grid from "@/components/astec/projetos/gridProjetos";
import Relatorios from "@/components/astec/projetos/Relatorios";
import { ProjetosService } from "../../../services/astec/projetos";
import { paginacaoProjetosHelper } from "@/store/helpers/vuex/astec";

export default {
  components: {
    Grid,
    Filtro,
    Relatorios
  },

  computed: {
    ...paginacaoProjetosHelper({
      state: ["currentPage", "pageSize", "total"],
      getters: ["currentPage", "pageSize", "total"],
      actions: []
    }).computed
  },

  data() {
    return {
      filtro: {},
      limparFiltro: false,
      filtroProjetoAstec: {},
      loadingGridProjetos: false,
      projetosListados: {
        data: [],
        total: 0,
        current_page: 0
      },
      mensagemGrid: "Nenhum projeto encontrado.",
    };
  },

  methods: {
    ...paginacaoProjetosHelper({
      actions: ["resetarPaginacao"]
    }).methods,

    async atualizarFiltro(filtro, callback) {
      if (filtro === null) {
        this.projetosListados = {
          data: [],
          total: 0,
          current_page: 1
        };
        await this.resetarPaginacao();

        if (typeof callback === "function") callback();
      }

      try {
        this.loadingGridProjetos = true;
        this.filtroProjetoAstec = filtro || {};

        const page = filtro.page || this.currentPage || 1;
        const perPage = filtro.per_page || this.pageSize || 10;

        const objFiltrado = await ProjetosService.buscarItensProjetos(
          filtro,
          page,
          perPage
        );

        this.projetosListados = objFiltrado || {
          data: [],
          total: 0,
          current_page: page
        };

        if (typeof callback === "function") callback();
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingGridProjetos = false;
      }
    }
  }
};
</script>
